/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable func-names */
import React, { useRef } from 'react';
import { FiArrowDown } from 'react-icons/fi';
import { Link } from 'gatsby';
import HomeBackgroundReel from './HomeBackgroundReel';
import ClutchWidget from '../ClutchWidget';

const HomeHeader = () => {
  const scrollRef = useRef(null);
  const executeScroll = () => {
    const h = document.documentElement.clientHeight;
    window.scrollTo({
      behavior: 'smooth',
      left: 0,
      top: h - 150
    });
  };

  return (
    <>
      <div className="home-header">
        <HomeBackgroundReel>
          <div className="body-header">
            <div />
            <div className="container inherit">
              {/*
              If you want to change title or description text, make sure to generate new fonts for them!!
              Current fonts are subsetted using https://everythingfonts.com/subsetter from Roboto 700 and Merriweather 300 respectivaly, and they contain only the letters used in current title and description.

              Fonts are located in src/assets/fonts/
             */}
              {/* {animated ? (
                <h1 className="animated-title">
                  <Typed
                    phrases={[
                      'Welcome to ULAM LABS!',
                      'Your idea.^1000 Our code.' // ^1000 means a second delay
                    ]}
                  />
                </h1>
              ) : (
                  <h1 className="title xs-version">Welcome to ULAM LABS!</h1>
                )} */}
              <h1>
                Custom Software Development <br className="d-none d-lg-block" />{' '}
                for Crypto, Fintech, and Startups
              </h1>
              <h2 className="description">
                Build and scale your products with world-class Python and
                blockchain teams.
              </h2>
            </div>
            <div className="container inherit clutch-header">
              <ClutchWidget />
            </div>
          </div>
        </HomeBackgroundReel>
      </div>
      <div className="beam-header">
        <div className="container container-full">
          <div className="content-beam">
            <div
              className="arrow"
              id="scroll-down"
              ref={scrollRef}
              onClick={executeScroll}
            >
              <FiArrowDown />
            </div>
            <div className="container">
              <div className="pistil">
                <div className="tt">Your trusted technology partner</div>
                <div className="dd">
                  Build powerful applications and extend your team with our
                  skilled software developers.
                </div>
                <Link to="/software-services/" className="btn btn-main">
                  Read more
                </Link>
              </div>
              <div className="pistil">
                <div className="tt">Efficient development methods</div>
                <div className="dd">
                  Know all about your project–what happens, when it happens, and
                  how it happens.
                </div>
                <Link to="/how-we-work/" className="btn btn-main">
                  Read more
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeHeader;
